(function(){
  function boot(){
    var hd = document.querySelector('.m-hd');
    if(!hd || hd.dataset.mHdReady) return;
    hd.dataset.mHdReady = '1';
    var drawer = document.querySelector('.m-dr');
    var openBtn = hd.querySelector('[data-m-menu]');
    var srch = hd.querySelector('.m-hd__srch');
    var srchBtn = hd.querySelector('[data-m-search]');

    function setDrawer(on){
      if(!drawer) return;
      drawer.classList.toggle('is-open', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
      if(openBtn) openBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    if(openBtn) openBtn.addEventListener('click', function(){ setDrawer(true); });
    if(drawer){
      drawer.querySelectorAll('[data-m-close]').forEach(function(el){
        el.addEventListener('click', function(){ setDrawer(false); });
      });
    }
    if(srchBtn && srch){
      srchBtn.addEventListener('click', function(){
        var on = !srch.classList.contains('is-open');
        srch.classList.toggle('is-open', on);
        srchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if(on){ var f = srch.querySelector('input'); if(f) f.focus(); }
      });
    }
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      setDrawer(false);
      if(srch) srch.classList.remove('is-open');
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
